import { copyFor } from '../../copy/copy';

const feedbackLeftDefault = () => copyFor('feedback', 'farSide', 'sentimentpoll');
const feedbackRightDefault = () => copyFor('feedback', 'farSide', 'sentimentpoll');
const feedbackCenterDefault = () => copyFor('feedback', 'center', 'sentimentpoll');

export const getFeedbackText = (sentimentAction, resultDistribution, answer) => {
    if (resultDistribution.length < 1) {
        return '';
    }
    const value = ind => (ind + 1) / resultDistribution.length;
    const totalCount = resultDistribution.reduce((sum, item) => sum + item, 0);
    const mean =
        resultDistribution
            .map((count, ind) => value(ind) * count)
            .reduce((sum, item) => sum + item, 0) / totalCount;
    const stdDev = Math.sqrt(
        resultDistribution
            .map((count, ind) => count * Math.pow(mean - value(ind), 2))
            .reduce((sum, item) => sum + item, 0) /
            (totalCount - 1)
    );

    if (answer < mean - stdDev) {
        return sentimentAction.feedbackLeft || feedbackLeftDefault();
    } else if (answer > mean + stdDev) {
        return sentimentAction.feedbackRight || feedbackRightDefault();
    }
    return sentimentAction.feedbackCenter || feedbackCenterDefault();
};

export const sumDistributionRange = (distribution, start, end) =>
    distribution.slice(start, end).reduce((arr, curr) => arr + curr);



// WEBPACK FOOTER //
// ./src/utils/sentimentPoll/helpers.js